module.exports = __webpack_public_path__ + "img/79ne.2366f86d.svg";